import { useStepsStore } from "./steps.store";

export const setCurrentStep = (step: number) => {
  useStepsStore.setState({ currentStep: step });
};

export const setMaxSteps = (max: number) => {
  useStepsStore.setState({ maxSteps: max });
};

export const setNextStepDisabled = (disabled: boolean) => {
  useStepsStore.setState({ nextStepDisabled: disabled });
};
